import { createWebHistory, createRouter } from "vue-router";
import EmpresaView from "@/components/views/private/EmpresaView.vue";
import PrefilUsuarioEmpresaView from "@/components/views/private/PrefilUsuarioEmpresaView.vue";
import ProductosView from "@/components/views/private/ProductosView.vue";
import ProductoFormView from "@/components/views/private/ProductoFormView.vue";
import InvitacionesView from "@/components/views/private/InvitacionesView.vue";
import AsignarInvitacionView from "@/components/views/private/AsignarInvitacionView.vue";

import LoginView from "@/components/views/LoginView.vue";
import CatalogoView from "@/components/views/CatalogoView.vue";
import CatalogoMarcoView from "@/components/views/CatalogoMarcoView.vue";

import PageNotFound from "@/components/commons/PageNotFound.vue";
import PublicPageNotFound from "@/components/commons/PublicPageNotFound.vue";

const routes = [
  {
    path: "/",
    component: LoginView,
  },
  {
    path: "/catalogo/:id",
    component: CatalogoView,
  },
  {
    path: "/catalogoMarco/:id",
    component: CatalogoMarcoView,
  },
  {
    path: "/invitaciones",
    component: InvitacionesView,
    meta: { requiresAuth: true },
  },
  {
    path: "/invitaciones/:idGrupoInvitacion",
    component: InvitacionesView,
    meta: { requiresAuth: true },
  },
  {
    path: "/asignarInvitacion/:idGrupoInvitacion/:id",
    component: AsignarInvitacionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/empresa",
    component: EmpresaView,
    meta: { requiresAuth: true },
  },
  {
    path: "/perfil",
    component: PrefilUsuarioEmpresaView,
    meta: { requiresAuth: true },
  },
  {
    path: "/productos",
    component: ProductosView,
    meta: { requiresAuth: true },
  },
  {
    path: "/producto",
    component: ProductoFormView,
    meta: { requiresAuth: true },
  },
  {
    path: "/producto/:id",
    component: ProductoFormView,
    meta: { requiresAuth: true },
  },
  {
    path: "/:catchAll(.*)",
    component: PageNotFound,
  },  
  {
    path: "/catalogo/:catchAll(.*)",
    component: PublicPageNotFound,
  },  



    {
    path: "/test",
    component: CropperView,
    meta: { requiresAuth: true },
  },

];

import { createWebHashHistory } from 'vue-router'
import seguridadServices from "@/services/seguridad.services";
import { UsuarioEmpresa } from "qreventos-suite/src/services/suite.interfaces";
import CropperView from "@/components/commons/CropperView.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const usuarioEmpresa: UsuarioEmpresa = seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa;
    if (usuarioEmpresa) {
      next();
    } else {
      next('/');
    }
  } else {
    next();
  }
});

export default router;